import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { TiposDocumentoSunatConstant } from 'constants/index'

const TipoDocumentoFormGroup = ({ iError, iTouched, fIsSubmitting, handleChange, values, setValues }) => {
  const onChange = React.useCallback(
    e => {
      handleChange(e)

      const nuevoValor = e.target.value

      values.tipoDocumento = nuevoValor
      values._idConductor = ''
      values._idDireccion = ''
      values._idPlaca = ''
      values._idTransportista = ''
      values.codigoMotivo = ''
      values.comentario = ''
      values.fechaEntrega = ''
      values.fechaTransporte = ''
      values.modalidad = ''
      values.numeroDocumento = ''
      values.serieDocumento = ''

      setValues(values)
    },
    [handleChange, values, setValues]
  )

  return (
    <Form.Group>
      <Form.Label text='TIPO DOCUMENTO' htmlFor='select-tipoDocumento' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='tipoDocumento'>
          {({ field }) => (
            <Form.Select
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              onChange={onChange}
              id='select-tipoDocumento'
            >
              <option value=''>Seleccionar</option>
              {TiposDocumentoSunatConstant.__transferenciasArray.map((val, key) => (
                <option key={key} value={val.id}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoDocumentoFormGroup)
